<template>
  <div class="product-detail-view" :class = "{'clear-header':isWechatBrowser}">
    <my-header class="top-title" v-if="!isWechatBrowser" title="宝贝详情" :showBack="true"></my-header>
    <div class="product-tab">
      <div class="product-tab-item" :class="{'selected':productTab == '0'}" @click = "changeTab('0')">宝贝信息</div>
      <div class="product-tab-item" :class="{'selected':productTab == '1'}" @click = "changeTab('1')">详情展示</div>
    </div>
    <div v-if="productTab == '0'" class="product-info general-box-shadow">
      <img class="product-first-photo" :src="productFirstPhoto">
      <div class="product-name">{{productDetail.name}}</div>
      <div class="product-sku">¥{{productDetail.price}}/{{productDetail.unit}}</div>
      <div class="project-select-spec" @click="openSelectView">
        <div>规格<span>选择规格</span></div>
        <img src="../../assets/index/icon-more-btn.png"/>
      </div>
    </div>
    <div v-if="productTab == '0'" @click="backShop" class="shop-info general-box-shadow" >
      <img class="shop-logo" :src="dealerShop.logo">
      <div class="shop-detail-info">
        <div class="shop-name">{{dealerShop.name}}</div>
        <div class="shop-trade-info">
          <div class="trade-info-item">订单数<span class="num">{{dealerShop.orderNum}}</span></div>
          <div class="trade-info-item">交易数<span class="num">{{dealerShop.sales}}</span></div>
        </div>
      </div>
    </div>
    <div v-if="productTab == '1' && productDetail.detail" class="product-detail">
      <div v-html="productDetail.detail"></div>
    </div>
    <div v-if="productTab == '1' && !productDetail.detail">
      <div class="black-page">
        <img src="../../assets/icon-no-img.png">
        <div class="tip">商家很懒一句描述都没有留下!</div>
      </div>
    </div>

    <div class="product-footer border-top-style">
      <div @click="leaveMeg" class="footer-operation-left">
        <img src="../../assets/icon/icon-consult.png"><div>咨询</div>
      </div>
      <div v-if="!isFavoriteProduct" @click="favoriteProduct" class="footer-operation-left">
        <img  src="../../assets/icon/icon-shop-unfavorite.png">
        <div>收藏</div>
      </div>
      <div v-if="isFavoriteProduct" @click="cancelFavoriteProduct" class="footer-operation-left">
        <img src="../../assets/icon/icon-favorited.png">
        <div>收藏</div>
      </div>
      <div @click="openSelectView" class="footer-operation-right add-shop-cart">加入购物车</div>
      <div @click="openSelectView" class="footer-operation-right fast-pay">立即购买</div>
    </div>
    <div v-if="showSelectBuyNum" class="pay-box"></div>
    <div v-if="showSelectBuyNum" class="mask-view">
      <div class="select-spec-view" style="transition:transform 500ms ease 0ms, bottom;transform-origin:50% 50% 0px;bottom:0px;z-index: 1002">
        <div class="select-title">
          <div>选择规格</div>
          <img @click="closeSelectView" class="icon-closed" src="../../assets/icon-close-btn.png">
        </div>
        <div class="select-content">
          <div class="select-content-row">
            <div class="select-content-row-key">数量</div>
            <div class="select-content-row-value">
              <div class="buy-num-group">
                <div v-if="productNum < 1" class="group-item group-left">
                  <img src="../../assets/icon-product-minus-disable.png"/>
                </div>
                <div v-if="productNum >= 1" @click="reduceProductNum" class="group-item group-left">
                  <img src="../../assets/icon-product-minus.png"/>
                </div>
                <div class="group-item group-input " style="width: 15%;border-top: solid 1px rgba(224, 221, 221,0.7);border-bottom: solid 1px rgba(224, 221, 221,0.7)"><input v-model="productNum"></div>
                <div @click="plusProductNum" class="group-item group-right">
                  <img src="../../assets/icon-product-plus.png"/>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="select-footer">
          <div @click="joinCart" class="select-footer-item add-shop-cart">加入购物车</div>
          <div @click="fastPay" class="select-footer-item fast-pay">立即购买</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import {Toast} from 'mint-ui'
  import Header from '../../components/header/Header'
  import productService from '../../service/product/ProductService'
  import favoriteService from '../../service/customer/FavoriteService'
  import customerCartService from '../../service/customer/CustomerCartService'
  import {imgUrl,shareIcon} from "../../config";
  import shareService from '../../service/share/ShareService'
  import session from '../../utils/Session'
  import envUtils from '../../utils/EnvUtils'

  export default {
    name: 'ProductDetail',
    components: {
      'my-header': Header,
    },
    data () {
      return {
        imgUrl: imgUrl,
        shareIcon:shareIcon,
        productId:'',
        dealerShop:{location:{}},
        productTab:'0',
        pageNo:1,
        productDetail:{},
        productImageList:[],
        isFavoriteProduct:false,
        productSku:{},
        showSelectBuyNum:false,
        productNum:1,
        isWechatBrowser:this.$verfyBrowserType(),
        productName:'',
        productFirstPhoto:''
      }
    },
    created(){
      this.productId = this.$route.query.productId;
      this.shopId = this.$route.query.shopId;
    },
    beforeMount () {
      document.title = this.$route.meta.title;
      this.loadProductDetail();
      session.isLogin().then(flag => {
        if(flag){
          this.checkFavoriteProduct();
        }
      });
    },
    methods: {
      async loadProductDetail(){
        let {code,msg,data} = await productService.detail(this.productId);
        if(code == '0'){
          this.productDetail = data.product;
          this.productName = this.productDetail.name;
          this.productImageList = data.imageUrlList;
          this.productFirstPhoto = this.productImageList[0];
          this.dealerShop = data.shop;
          this.productSku = data.skuMap[""];
          this.initWechatShare();
        }else {
          Toast(msg);
        }
      },
      async checkFavoriteProduct(){
        let {code,msg,data} = await favoriteService.favoriteCheck(this.productId,'1');
        if(code == '0'){
          this.isFavoriteProduct = data;
        }else {
          Toast(msg);
        }
      },
      leaveMeg(){
        if(this.dealerShop.msgQrcode){
          let shopQrcode = imgUrl + this.dealerShop.msgQrcode
          this.$router.push({name: 'ShopQrcode', query: {shopQrcode}})
        }else {
          Toast('该商家暂未上传二维码');
        }
      },
      async favoriteProduct(){
        const isLogin = await session.isLogin();
        if(isLogin){
          let {code,msg,data} = await favoriteService.addFavorite(this.productId,'1');
          if(code == '0'){
            this.isFavoriteProduct = !this.isFavoriteProduct;
            Toast('宝贝收藏成功!');
          }else {
            Toast('宝贝收藏失败!');
          }
        } else {
          session.userType('1');
          let backUrl = window.location.href.split('#')[1];
          if (envUtils.inLight()) {
            wx.miniProgram.navigateTo({url: `/pages/register/register?h5Url=${encodeURIComponent(backUrl)}`});
          } else {
            session.backUrl(backUrl)
            this.$router.push({name:'BindPhone'});
          }
        }
      },
      async initWechatShare(){
        let title = this.productName;// 分享标题
        let desc = this.productName; // 分享描述
        let link = window.location.href; // 分享链接
        link = link.replace(/#/, '?#');
        await shareService.wechatShare(title,desc,link,this.shareIcon);
      },
      async cancelFavoriteProduct(){
        let {code,msg,data} = await favoriteService.removeFavorite(this.productId,'1');
        if(code == '0'){
          this.isFavoriteProduct = !this.isFavoriteProduct;
          Toast('宝贝取消收藏成功!');
        }else {
          Toast('宝贝取消收藏失败!');
        }
      },
      backShop(){
        this.$router.push({name: 'ShopDetail', query: {shopId:this.shopId}})
      },
      async joinCart(){
        let {code,msg} = await customerCartService.joinCart(this.productId,this.productSku.id,this.productNum);
        if(code == '0'){
          Toast('添加成功!');
          this.showSelectBuyNum = false;
        }else {
          Toast(msg);
        }
      },
      async fastPay(){
        let {code,msg,data} = await customerCartService.joinCart(this.productId,this.productSku.id,this.productNum);
        if(code == '0'){
          this.showSelectBuyNum = false;
          this.$router.replace('/customer/cart');
          this.global.selectTab = 'customerCart';
        }else {
          Toast(msg);
        }
      },
      openSelectView(){
        this.showSelectBuyNum = true;
      },
      closeSelectView(){
        this.showSelectBuyNum = false
      },
      reduceProductNum(){
        this.productNum -= 1
      },
      plusProductNum(){
        this.productNum += 1
      },
      changeTab(tabSelected){
        this.productTab = tabSelected;
      }
    }
  }
</script>
<style lang="scss">
  @import '../../assets/style/common.scss';
  .product-detail-view {
    background-color: white;
    color: #191818;
    font-size: 0.32rem;
    padding-bottom: 1rem;
    .product-tab{
      display: flex;
      height: 0.9rem;
      margin-left: 0.3rem;
      line-height: 0.9rem;
      .product-tab-item{
        margin-right: 0.27rem;
        color: #7f7d7c;
      }
      .selected{
        font-size: 0.36rem;
        font-weight: bold;
        color: #191818;
      }
    }
    .product-info{
      width: 6.9rem;
      margin: 0 auto;
      img{
        width: 100%;
        height: 4rem;
        display: block;
      }
      .product-name{
        padding-top: 0.3rem;
        padding-left: 0.3rem;
      }
      .product-sku{
        padding: 0.16rem 0 0.3rem 0.3rem;
        color: #d54a33;
      }
      .project-select-spec{
        display: flex;
        justify-content: space-between;
        width: 6.27rem;
        height: 0.9rem;
        line-height: 0.9rem;
        margin: 0 auto;
        border-top: solid 1px #e0dedc;
        font-size: 0.28rem;
        color: #7f7d7c;
        span{
          margin-left: 0.27rem;
          font-size: 0.32rem;
          color: #191818;
        }
        img{
          width: 0.19rem;
          height: 0.33rem;
          margin-top: 0.3rem;
        }
      }
    }
    .product-detail{
      width: 6.9rem;
      margin: 0 auto;
      padding-bottom: 1rem;
      background-color: white;
      flex-grow: 1;
      overflow-y: scroll;
      flex-wrap: nowrap;
      img{
        width: 100%;
      }
      .no-detail{
        text-align: center;
        padding-top: 1rem;
        img{
          width: 1.5rem;margin-bottom: 0.5rem
        }
      }
    }
    .product-footer{
      position: fixed;
      display: flex;
      align-items: center;
      bottom: 0rem;
      width: 100%;
      height: 0.97rem;
      background: white;
      font-size: 0.24rem;
      .footer-operation-left{
        width:1.2rem;
        display:flex;
        flex-flow:column wrap;
        align-items:center;
        color: #222633;
        img{
          width: 0.38rem;
          margin-bottom: 0.07rem;
        }
      }
      .footer-operation-right{
        width:2.3rem;
        height: 0.6rem;
        margin-right: 0.2rem;
        line-height:0.6rem;
        border-radius: 0.6rem;
        text-align:center;
        font-size: 0.3rem;
        color:#ffffff;
        font-weight: inherit;
      }
    }
    .shop-info{
      display: flex;
      width: 6.9rem;
      height: 1.7rem;
      margin: 0.3rem auto;
      .shop-logo{
        width: 1.3rem;
        height: 1.3rem;
        margin: 0.2rem;
      }
      .shop-detail-info{
        padding-left: 0.14rem;
        .shop-name{
          padding-top: 0.1rem;
          padding-bottom: 0.3rem;
          font-size: 0.36rem;
        }
        .shop-trade-info{
          display: flex;
          font-size: 0.24rem;
          .trade-info-item{
            width: 2rem;
            height: 0.4rem;
            line-height: 0.45rem;
            margin-right: 0.2rem;
            background-color: #e0dedc;
            border-radius: 0.4rem;
            text-align: center;
            .num{
              padding-left: 0.12rem;
              font-size: 0.26rem;
            }
          }
        }
      }
    }
    .add-shop-cart{
      background:#70c285;
    }
    .fast-pay{
      background: #feac00;
    }
    .mask-view{
      width:100%;
      height:100%;
      position:fixed;
      z-index:100;
      background-color:rgba(236,236,235,0.5);
    }
    .select-spec-view{
      position:fixed;
      width:100%;
      height:6.88rem;
      background-color:#ffffff;
      z-index:10001;
      border-top-left-radius: 0.2rem;
      border-top-right-radius: 0.2rem;
      font-size: 0.36rem;
    }
    .select-title{
      display: flex;
      justify-content: space-between;
      width: 6.9rem;
      height: 0.95rem;
      margin: 0 auto;
      line-height: 1rem;
      .icon-closed{
        margin-top: 0.3rem;
        width: 0.29rem;
        height: 0.29rem;
      }
    }
    .select-content{
      width:100%;
      height: 5.42rem;
      margin-top: 0.7rem;
    }
    .select-content-row{
      width:100%;
      .select-content-row-key{
        width:7.30rem;
        margin-bottom:0.2rem;
        padding-left:0.3rem;
      }
      .select-content-row-value{
        width:7.4rem;
        display:flex;
        flex-flow:row wrap;
        padding-left:0.1rem;
      }
      .buy-num-group{
        padding-left:0.2rem;
        display:flex;
        flex-flow:row wrap;
        img{
          width: 0.5rem;
        }
        .group-item{
          display:inline-block;
          text-align:center;
          font-size:.24rem;
          vertical-align:middle;
          width: 0.5rem;
          height: 0.5rem;
        }
        .group-input{
          border-left:none;
          border-right:none;
          line-height: 0.45rem;
          height: 0.46rem;
          input{
            width: 70%;
            font-size: 0.22rem;
            text-align: center;
          }
        }
      }
    }
    .select-footer{
      position:fixed;
      bottom:0.3rem;
      left: 1.24rem;
      width:100%;
      height:0.6rem;
      line-height:0.65rem;
      text-align:center;
      color:#ffffff;
      display:flex;
      flex-flow:row wrap;
      .select-footer-item{
        width: 2.3rem;
        margin-right: 0.2rem;
        border-radius: 0.6rem;
        text-align: center;
        font-size: 0.3rem;
        font-weight: normal;
      }
    }
  }
</style>
